/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { Multicall2, Multicall2Interface } from '../Multicall2'

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'target',
            type: 'address'
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes'
          }
        ],
        internalType: 'struct Multicall2.Call[]',
        name: 'calls',
        type: 'tuple[]'
      }
    ],
    name: 'aggregate',
    outputs: [
      {
        internalType: 'uint256',
        name: 'blockNumber',
        type: 'uint256'
      },
      {
        internalType: 'bytes[]',
        name: 'returnData',
        type: 'bytes[]'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'address',
            name: 'target',
            type: 'address'
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes'
          }
        ],
        internalType: 'struct Multicall2.Call[]',
        name: 'calls',
        type: 'tuple[]'
      }
    ],
    name: 'blockAndAggregate',
    outputs: [
      {
        internalType: 'uint256',
        name: 'blockNumber',
        type: 'uint256'
      },
      {
        internalType: 'bytes32',
        name: 'blockHash',
        type: 'bytes32'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'success',
            type: 'bool'
          },
          {
            internalType: 'bytes',
            name: 'returnData',
            type: 'bytes'
          }
        ],
        internalType: 'struct Multicall2.Result[]',
        name: 'returnData',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'blockNumber',
        type: 'uint256'
      }
    ],
    name: 'getBlockHash',
    outputs: [
      {
        internalType: 'bytes32',
        name: 'blockHash',
        type: 'bytes32'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getBlockNumber',
    outputs: [
      {
        internalType: 'uint256',
        name: 'blockNumber',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getCurrentBlockCoinbase',
    outputs: [
      {
        internalType: 'address',
        name: 'coinbase',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getCurrentBlockDifficulty',
    outputs: [
      {
        internalType: 'uint256',
        name: 'difficulty',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getCurrentBlockGasLimit',
    outputs: [
      {
        internalType: 'uint256',
        name: 'gaslimit',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getCurrentBlockTimestamp',
    outputs: [
      {
        internalType: 'uint256',
        name: 'timestamp',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'addr',
        type: 'address'
      }
    ],
    name: 'getEthBalance',
    outputs: [
      {
        internalType: 'uint256',
        name: 'balance',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getL1BlockNumber',
    outputs: [
      {
        internalType: 'uint256',
        name: 'l1BlockNumber',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getLastBlockHash',
    outputs: [
      {
        internalType: 'bytes32',
        name: 'blockHash',
        type: 'bytes32'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'requireSuccess',
        type: 'bool'
      },
      {
        components: [
          {
            internalType: 'address',
            name: 'target',
            type: 'address'
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes'
          }
        ],
        internalType: 'struct Multicall2.Call[]',
        name: 'calls',
        type: 'tuple[]'
      }
    ],
    name: 'tryAggregate',
    outputs: [
      {
        components: [
          {
            internalType: 'bool',
            name: 'success',
            type: 'bool'
          },
          {
            internalType: 'bytes',
            name: 'returnData',
            type: 'bytes'
          }
        ],
        internalType: 'struct Multicall2.Result[]',
        name: 'returnData',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: 'requireSuccess',
        type: 'bool'
      },
      {
        components: [
          {
            internalType: 'address',
            name: 'target',
            type: 'address'
          },
          {
            internalType: 'bytes',
            name: 'callData',
            type: 'bytes'
          }
        ],
        internalType: 'struct Multicall2.Call[]',
        name: 'calls',
        type: 'tuple[]'
      }
    ],
    name: 'tryBlockAndAggregate',
    outputs: [
      {
        internalType: 'uint256',
        name: 'blockNumber',
        type: 'uint256'
      },
      {
        internalType: 'bytes32',
        name: 'blockHash',
        type: 'bytes32'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'success',
            type: 'bool'
          },
          {
            internalType: 'bytes',
            name: 'returnData',
            type: 'bytes'
          }
        ],
        internalType: 'struct Multicall2.Result[]',
        name: 'returnData',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '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'

export class Multicall2__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Multicall2> {
    return super.deploy(overrides || {}) as Promise<Multicall2>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): Multicall2 {
    return super.attach(address) as Multicall2
  }
  connect(signer: Signer): Multicall2__factory {
    return super.connect(signer) as Multicall2__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): Multicall2Interface {
    return new utils.Interface(_abi) as Multicall2Interface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Multicall2 {
    return new Contract(address, _abi, signerOrProvider) as Multicall2
  }
}
